import * as types from './action-types'
import { fromJS } from 'immutable'

const InitialState = fromJS({
  fetching: false,
  data: null
})

export default (state = InitialState, action) => {
  switch (action.type) {
    case types.REQUEST_CASE_STUDY_ROWS:
      return state.set('fetching', true)

    case types.RECEIVE_CASE_STUDY_ROWS:
      return state
        .set('data', fromJS(action.payload.data.message))
        .set('fetching', false)

    case types.ERROR_CASE_STUDY_ROWS:
      return state.set('fetching', false)

    default:
        return state
  }
}



// WEBPACK FOOTER //
// ./src/components/case-studies-container/reducer.js